/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import Flickity from "flickity";

const HTML = document.querySelector("body");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggle = document.querySelectorAll(".toggle-menu");
    if (toggle) {
      toggle.forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** BANNER HEADER */
    const header = document.querySelector(".main-header");
    if (header) {
      const sections = document.querySelectorAll("section.text-white");
      const BreakException = {};

      window.addEventListener("scroll", () => {
        if (sections) {
          try {
            sections.forEach((section) => {
              const bound = section.getBoundingClientRect();

              if (bound.y <= 0 && bound.bottom > 0) {
                HTML.classList.add("header-white");
                throw BreakException;
              } else {
                HTML.classList.remove("header-white");
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }
        }

        if (window.scrollY > header.offsetHeight * 0.3) {
          HTML.classList.add("scrolldown");
        } else {
          HTML.classList.remove("scrolldown");
        }
      });

      window.dispatchEvent(new Event("scroll"));
    }

    this.sticky();
    this.marquee();
    this.gallery();
    this.popin();
    this.sliderLineup();
    this.videoPlayer();
    this.inViewport();
  }

  sliderLineup() {
    const elts = document.querySelectorAll(".slider-lineup");

    if (elts) {
      elts.forEach((el) => {
        const slider = el.querySelector(".slider");

        if (slider) {
          const summary = el.querySelectorAll(".slider-summary a");
          const captions = el.querySelectorAll(".slider-captions .item");
          let current = -1;

          const flkty = new Flickity(slider, {
            pageDots: false,
            wrapAround: true,
            autoPlay: 3000,
            pauseAutoPlayOnHover: true,
            on: {
              select(index) {
                /** SUMMARY */
                if (summary.length ) {
                  if (summary[current])
                    summary[current].classList.remove("active");
                  summary[index].classList.add("active");
                }

                /** CAPTIONS */
                if (captions) {
                  if (current >= 0) {
                    gsap.to(captions[current], {
                      duration: 0.4,
                      ease: "circ.inOut",
                      autoAlpha: 0,
                      y: "-100%",
                    });
                  }

                  gsap.to(captions[index].closest(".slider-captions"), {
                    height: captions[index].offsetHeight,
                    duration: 0.4,
                    ease: "circ.inOut",
                  });

                  gsap.fromTo(
                    captions[index],
                    {
                      y: "100%",
                      autoAlpha: 0,
                    },
                    {
                      duration: 0.4,
                      ease: "circ.inOut",
                      autoAlpha: 1,
                      y: "0%",
                    }
                  );
                }

                current = index;
              },
            },
          });

          if (summary) {
            summary.forEach((link, i) => {
              link.addEventListener("click", (e) => {
                e.preventDefault();

                flkty.select(i);
              });
            });
          }
        }
      });
    }
  }

  gallery() {
    const elts = document.querySelectorAll(".gallery");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          pageDots: false,
          wrapAround: true,
          cellAlign: "center",
          autoPlay: 3000,
          pauseAutoPlayOnHover: true
        });
      });
    }
  }

  popin() {
    const triggers = document.querySelectorAll("[data-popin]");

    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();

          const target = document.querySelector(trigger.dataset.popin);
          if (target) {
            target.classList.add("show");

            const video = target.querySelector(".player-js");
            if (video) video.dispatchEvent(new Event("play"));

            const close = target.querySelector(".trigger-close");
            if (close) {
              close.addEventListener("click", (e) => {
                e.preventDefault();
                target.classList.remove("show");
                if (video) video.dispatchEvent(new Event("pause"));
              });
            }
          }
        });
      });
    }
  }

  videoPlayer() {
    const players = document.querySelectorAll(".player-js");

    if (players) {
      players.forEach((player) => {
        const video = player.querySelector("video:not(.preview)");

        if (video) {
          /** BUILD CONTROLS */
          const controls = document.createElement("div");
          controls.classList.add("controls");
          player.append(controls);

          const playPause = document.createElement("a");
          playPause.classList.add("play-pause");
          controls.append(playPause);

          const progress = document.createElement("div");
          progress.classList.add("progress");
          controls.append(progress);
          const bar = document.createElement("div");
          bar.classList.add("bar");
          progress.append(bar);

          const sound = document.createElement("a");
          sound.classList.add("sound");
          controls.append(sound);

          const fullscreen = document.createElement("a");
          fullscreen.classList.add("fullscreen");
          controls.append(fullscreen);

          const btnPlay = player.querySelector("[data-play]");
          if (btnPlay) {
            btnPlay.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }
          const trigger = player.querySelector("[data-trigger-player]");
          if (trigger) {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }

          /** EVENTS LISTENER */
          // CLICK
          playPause.addEventListener("click", (e) => {
            e.preventDefault();
            if (video.paused) video.play();
            else video.pause();
          });

          // PROGRESS CLICK
          progress.addEventListener("click", (e) => {
            const bounding = progress.getBoundingClientRect();
            const percent = (e.clientX - bounding.x) / bounding.width;

            video.currentTime = percent * video.duration;
          });

          // EVENTS
          player.addEventListener("play", () => {
            video.play();
          });
          player.addEventListener("pause", () => {
            video.pause();
          });

          // CLICK
          video.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) video.play();
            else video.pause();
          });

          // FULLSCREEN
          fullscreen.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.fullscreenElement) {
              video.requestFullscreen();
            } else if (video.exitFullscreen) {
              video.exitFullscreen();
            }
          });

          // SOUND
          sound.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.muted) {
              video.muted = true;
              player.classList.add("soundoff");
            } else {
              video.muted = false;
              player.classList.remove("soundoff");
            }
          });

          video.addEventListener("mouseenter", () => {
            player.classList.add("is-mouseenter");
          });
          video.addEventListener("mouseleave", () => {
            player.classList.remove("is-mouseenter");
          });

          // IS PLAYING
          video.addEventListener("playing", () => {
            player.classList.add("is-playing");
          });
          // IS PAUSE
          video.addEventListener("pause", () => {
            player.classList.remove("is-playing");
          });

          // TIMEUPDATE
          video.addEventListener("timeupdate", () => {
            gsap.set(bar, {
              width: `${(video.currentTime / video.duration) * 100}%`,
            });
          });
        }
      });
    }
  }

  marquee() {
    const marquees = document.querySelectorAll(".marquee:not(.ready)");

    if (marquees) {
      marquees.forEach((el) => {
        el.classList.add('ready')
        const line = el.querySelector(".line");

        let scrollDirection = 1; // 1 = gauche, -1 = droite
        const speed = 20; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 60) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;

          requestAnimationFrame(animate);
        };

        let lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            scrollDirection = 1; // Scroll vers le bas : gauche
          } else if (currentScrollY < lastScrollY) {
            scrollDirection = -1; // Scroll vers le haut : droite
          }
          lastScrollY = currentScrollY;
        });

        // Lance l'animation
        requestAnimationFrame(animate);
      });
    }
  }

  sticky() {
    const elts = document.querySelectorAll("[data-sticky]");

    if (window.innerWidth < 1024) return;

    if (elts) {
      elts.forEach((el) => {
        const parent =
          el.dataset.sticky != ""
            ? document.querySelector(el.dataset.sticky)
            : el.parentNode;

        const clone = el.cloneNode(true);

        gsap.set(el, { autoAlpha: 0 });
        el.parentNode.append(clone);
        this.lazyload.update();
        // this.marquee()

        window.addEventListener("resize", () => {
          const bound = el.getBoundingClientRect();
          gsap.set(clone, {
            width: `${bound.width}px`,
            top: 0,
            position: "absolute",
            autoAlpha: 1,
          });
        });
        window.dispatchEvent(new Event("resize"));

        const offset = el.dataset.stickyOffset
          ? document.querySelector(el.dataset.stickyOffset).offsetHeight
          : 0;

        window.addEventListener("scroll", () => {
          const containerRect = parent.getBoundingClientRect();
          const stickyRect = el.getBoundingClientRect();

          if (
            containerRect.top - offset <= 0 &&
            containerRect.bottom - stickyRect.height - offset >= 0
          ) {
            // Simule "position: sticky"
            clone.style.position = "fixed";
            clone.style.top = `${offset}px`;
          } else {
            clone.style.position = "absolute";

            if (containerRect.bottom - stickyRect.height - offset < 0) {
              clone.style.top = `${containerRect.height - stickyRect.height}px`;
            } else {
              clone.style.top = "0";
            }
          }
        });
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
